import { useState } from "react";
import { toast } from "sonner";
import { Mail, MapPin, Phone } from "lucide-react";
import { apiClient, formatApiError } from "@/lib/api";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (!form.name || !form.email || !form.subject || !form.message) {
      toast.error("Please complete all fields");
      return;
    }
    setLoading(true);
    try {
      await apiClient.post("/inquiries", form);
      toast.success("Message sent. We'll be in touch.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20" data-testid="contact-page">
      <div className="bgc-eyebrow text-[#c8102e]">CONTACT</div>
      <h1 className="font-display text-6xl tracking-tight uppercase mt-3">Send a Signal.</h1>
      <p className="text-[#9ca3af] mt-4 max-w-xl">
        Custom build inquiry, dealer question, or just want to say hi? Drop us a line.
      </p>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 mt-14">
        <div className="space-y-6">
          <InfoBlock icon={<Mail className="w-5 h-5" />} label="EMAIL" value="hello@badgirlcustoms.com" />
          <InfoBlock icon={<Phone className="w-5 h-5" />} label="PHONE" value="(503) 555-0149" />
          <InfoBlock icon={<MapPin className="w-5 h-5" />} label="HQ" value="Phoenix, Arizona, USA" />
        </div>

        <form onSubmit={submit} className="lg:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4 border border-white/10 p-8 bg-[#0a0a0a]">
          <label className="block">
            <span className="bgc-eyebrow block mb-2">Name</span>
            <input data-testid="contact-name" className="input-dark w-full" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
          </label>
          <label className="block">
            <span className="bgc-eyebrow block mb-2">Email</span>
            <input data-testid="contact-email" type="email" className="input-dark w-full" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </label>
          <label className="block md:col-span-2">
            <span className="bgc-eyebrow block mb-2">Subject</span>
            <input data-testid="contact-subject" className="input-dark w-full" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} />
          </label>
          <label className="block md:col-span-2">
            <span className="bgc-eyebrow block mb-2">Message</span>
            <textarea data-testid="contact-message" rows={6} className="input-dark w-full resize-none" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
          </label>
          <div className="md:col-span-2">
            <button type="submit" disabled={loading} className="btn-primary" data-testid="contact-submit">
              {loading ? "SENDING…" : "SEND MESSAGE"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function InfoBlock({ icon, label, value }) {
  return (
    <div className="border border-white/10 p-6">
      <div className="text-[#c8102e]">{icon}</div>
      <p className="bgc-eyebrow mt-3">{label}</p>
      <p className="text-white mt-1">{value}</p>
    </div>
  );
}
